import type { GetReportRow } from '@/Pages/Reports/types/reports.types';
import type { ReportInfo } from '@/Stores/waiting-report.store';

export interface CategorizedReports {
  completed: GetReportRow[];
  hasRunning: boolean;
  hasErrored: boolean;
}

/**
 * Categoriza relatórios baseado em seu status
 * @param allReports - Todos os relatórios disponíveis da API
 * @param reportInfoArray - Os relatórios que estamos rastreando
 * @returns Relatórios categorizados por status
 */
export function categorizeReports(
  allReports: GetReportRow[],
  reportInfoArray: ReportInfo[],
): CategorizedReports {
  const completed: GetReportRow[] = [];
  let hasRunning = false;
  let hasErrored = false;

  for (const info of reportInfoArray) {
    const report = allReports.find(r => String(r.id) === String(info.id));
    if (!report) continue;

    switch (report.status) {
      case 'completed':
        completed.push(report);
        break;
      case 'running':
        hasRunning = true;
        break;
      case 'errored':
        hasErrored = true;
        break;
    }
  }

  return { completed, hasRunning, hasErrored };
}
